import { Component } from 'react';
import PropTypes from 'prop-types';
import UITextInput from 'UIComponents/input/UITextInput';
import { jsx as _jsx } from "react/jsx-runtime";
export default class LabelInput extends Component {
  /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
  constructor(props) {
    super(props);
    this.onChange = ({
      target: {
        value
      }
    }) => {
      value = value.replace(' ', '');
      this.setState({
        value
      });
    };
    this.onBlur = () => {
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      this.props.onKeyChange(this.state.value);
    };
    this.state = {
      value: props.label
    };
  }

  /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */

  render() {
    /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
    const {
      value
    } = this.state;
    return /*#__PURE__*/_jsx(UITextInput, {
      onBlur: this.onBlur
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */,
      onChange: this.onChange,
      value: value
    });
  }
}

/*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
LabelInput.propTypes = {
  label: PropTypes.string,
  onKeyChange: PropTypes.func
};